import { Stack } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormSelect } from 'src/components/Forms/FormSelect/form-select';
import { FormTextField } from 'src/components/Forms/FormTextField/form-text-field';
import { BLOCK_TEXT_FIELD_PROPS } from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/field-props';
import { ImageUrlField } from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/image-url-field';
import {
  blockFieldName,
  type LandingPageFormValues,
  MEDIA_KIND_OPTIONS,
  type MediaBlockPrefix,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';
import { URL_FIELD_RULES } from 'src/pages/Settings/memberships/utils/url-field-rules';

interface MediaFieldsProps {
  index: number;
  prefix: MediaBlockPrefix;
  readOnly: boolean;
}

/** The media picker hero and content blocks share: no media, an image, or a video. */
export const MediaFields = ({ index, prefix, readOnly }: MediaFieldsProps) => {
  const { control } = useFormContext<LandingPageFormValues>();
  const mediaKind = useWatch({ control, name: blockFieldName(index, `${prefix}MediaKind`) });

  return (
    <Stack gap={2.5}>
      <FormSelect
        type="select"
        name={blockFieldName(index, `${prefix}MediaKind`)}
        label="Media"
        options={MEDIA_KIND_OPTIONS}
        disabled={readOnly}
        fullWidth
      />

      {mediaKind === 'image' ? (
        <ImageUrlField index={index} prefix={prefix} label="Image URL" readOnly={readOnly} />
      ) : null}

      {mediaKind === 'video' ? (
        <Stack gap={2.5}>
          <FormTextField
            type="textfield"
            name={blockFieldName(index, `${prefix}VideoUrl`)}
            label="Video URL"
            rules={URL_FIELD_RULES}
            disabled={readOnly}
            textFieldProps={BLOCK_TEXT_FIELD_PROPS}
            description="YouTube, Vimeo and video file links play on the page. Other links open in a new tab."
          />
          <FormTextField
            type="textfield"
            name={blockFieldName(index, `${prefix}VideoTitle`)}
            label="Video title"
            disabled={readOnly}
            textFieldProps={BLOCK_TEXT_FIELD_PROPS}
          />
          <FormTextField
            type="textfield"
            name={blockFieldName(index, `${prefix}VideoCaption`)}
            label="Video caption"
            disabled={readOnly}
            textFieldProps={BLOCK_TEXT_FIELD_PROPS}
          />
        </Stack>
      ) : null}
    </Stack>
  );
};
